import React from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Text } from '@yandex-360/orb-components/dist/components/Text';

import { STORE_URL_UNIVERSAL_UNSUPPORTED } from '../../../../helpers/constants';
import { i18n } from '../../../../helpers/i18n';
import I18N from '../../../i18n';
import Link from '../../../link';
import { PngImage } from '../../../png-image';
import styles from './styles.css';

export const UnsupportedTouchErrorPage: React.FC = () => {
    return (
        <div className={styles.unsupportedTouchErrorPage}>
            <PngImage name="touchStubPhoneAndLogo" className={styles.image} />
            <Text className={styles.title} typography="heading-lg">
                {i18n('error-page', 'usupported-browser-title-v2')}
            </Text>
            <Text className={styles.description} typography="body-lg-regular">
                <I18N keyset="error-page" loc="unsupported-browser-subtitle-touch">
                    <Link
                        className={styles.yabroLink}
                        data-ref="link-yabro"
                        view="default"
                        href="https://browser.yandex.ru"
                        target="_blank"
                    />
                </I18N>
            </Text>
            <Button elementType="a" href={STORE_URL_UNIVERSAL_UNSUPPORTED} target="_blank" view="brand" size="lg">
                {i18n('error-page', 'download-yandex-telemost')}
            </Button>
        </div>
    );
};
